import React from 'react';
import DestinationTemplate from '../../components/DestinationTemplate';

const MalaysiaPage = () => {
  return <DestinationTemplate destinationId="malaysia" />;
};

export default MalaysiaPage;
